import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/Global.css';
import './styles/InternalNavBar.css';
import './styles/Table.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
